<template>
	<div>
		<div class="row">
			<div class="col-sm-12 col-md-6">
				<app-breadcrumb page-title="Placement History" />
			</div>
			<div class="col-sm-12 col-md-6 breadcrumb-side-button">
				<div class="float-md-right mb-3 mb-sm-3 mb-md-0"></div>
			</div>
		</div>
		<hr
			style="
				border-top: 2px solid black;
				font-weight: bold;
				margin-bottom: 20px !important;
			"
		/>
		<app-table :id="tableId" :options="options" @action="getListAction" />
	</div>
</template>

<script>
import CoreLibrary from "../../../../../../../../core/helpers/CoreLibrary.js";
import { PlacementHistoryTableSchema } from "./PlacementHistoryTableSchema";
import { urlGenerator } from "../../../../../../../Helpers/AxiosHelper";

export default {
	extends: CoreLibrary,
	inject: ["eventHub"],
	name: "PlacementHistoryTable",
	mixins: [PlacementHistoryTableSchema],
	props: {
		value: {
			type: Object,
			default: () => {
				return {
					code: "",
					name: "",
					is_active: "",
				};
			},
		},
		leadProfilePlacementSubTabLists: {
			type: Array,
			default: () => {
				return [];
			},
		},
	},
	created() {
		// this.options.columns = [...this.tableColumns, this.actionObj];
		this.options.columns = [...this.tableColumns];
	},
	methods: {
		/**
		 * for open add edit modal
		 */
		openAddEditModal() {
			this.isAddEditModalActive = true;
		},

		/**
		 * for close add edit modal
		 */
		closeAddEditModal() {
			$("#placement-history-table-form").modal("hide");
			this.isAddEditModalActive = false;
			this.reSetData();
		},

		/**
		 * $emit Form datatable action
		 */
		getListAction(rowData, actionObj, active) {
			this.rowData = rowData;

			if (actionObj.title == "Delete") {
				this.openDeleteModal();
			} else if (actionObj.title == this.$t("edit")) {
				this.selectedUrl = "/transaction/placement/" + this.rowData.id;
				this.openAddEditModal();
			} else if (
				actionObj.title != "Delete" ||
				actionObj.title != this.$t("edit")
			) {
				// this.selectedUrl = `${this.Endpoint}/${rowData.id}`;
				this.openAddEditModal();
			}
		},

		/**
		 * for open confirmation modal
		 */
		openDeleteModal() {
			this.deleteConfirmationModalActive = true;
		},

		/**
		 * confirmed $emit Form confirmation modal
		 */
		confirmed() {
			// let url = `${this.Endpoint}/${this.rowData.id}`;
			let url = PLACEMENT + "/" + this.rowData.id;
			this.deleteLoader = true;
			this.axiosDelete(url)
				.then((response) => {
					this.deleteLoader = false;
					$("#demo-delete").modal("hide");
					this.cancelled();
					this.$toastr.s(response.data.message);
				})
				.catch(({ error }) => {
					// Trigger after error
				})
				.finally(() => {
					this.$hub.$emit("reload-" + this.tableId);
				});
		},

		/**
		 * cancelled $emit Form confirmation modal
		 */
		cancelled() {
			this.deleteConfirmationModalActive = false;
			this.reSetData();
		},
		reSetData() {
			this.rowData = {};
			this.selectedUrl = "";
		},
		reloadTable() {
			this.$hub.$emit("reload-" + this.tableId);
		},
		exportAll() {
			window.location.replace(urlGenerator(DATATABLE_EXPORT));
		},
		formattedDate(payloadDate) {
			const originalDate = payloadDate;
			const date = new Date(originalDate);

			const year = date.getFullYear();
			const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are zero-based
			const day = date.getDate().toString().padStart(2, "0");

			const formattedDate = `${year}-${month}-${day}`;

			return formattedDate;
		},
	},
};
</script>
